'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
/**
 * Sans-serif font
 *
 * @see https://zpl.io/V4ep7Jy
 */

var base = "'Source Sans Pro', sans-serif";
/**
 * Monospace font
 *
 * @see https://zpl.io/V4ep7Jy
 */

var mono = "'Source Code Pro', monospace";
exports.base = base;
exports.mono = mono;